<template>
  <div class="animated fadeIn">
    <div class="row no-gutters mb-3">
      <div class="col-12 col-md-6 mb-3 mb-md-0">
        <div class="display-1 my-auto">{{ reportTitle() }}</div>
      </div>
    </div>

    <div class="row" v-if="hasUserList()">
      <div class="col-12 col-lg-12">
        <!--Imported Users Data -->
        <b-card :class="widgetClasses(importUserInfo)">
          <dashboard-widget
          :widgetType="'block'"
          :widgetInfo="importUserInfo">
          </dashboard-widget>
        </b-card>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 col-lg-6">
        <div class="mr-md-4 pb-3 rounded shadow-sm">
          <!--Upload Users -->
          <b-card :class="widgetClasses(uploadUsersInfo)">
            <dashboard-widget
            :widgetType="'block'"
            :widgetInfo="uploadUsersInfo">
            </dashboard-widget>
          </b-card>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="ml-md-4 pb-3 rounded shadow-sm">
          <!--Download File -->
          <b-card :class="widgetClasses(downloadTemplateInfo)">
            <dashboard-widget
            :widgetType="'block'"
            :widgetInfo="downloadTemplateInfo">
            </dashboard-widget>
          </b-card>
        </div>
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import DashboardWidget from '../../presentational/widgets/DashboardWidget';

export default {
  data() {
    return {
      importUserInfo: {
        widgetTitle: sessionStorage.getItem('userAgency'),
        linkTitle: null,
        widgetDescription: `These users were not added to the system due to the following errors.
        All errors must be rectified for admission. Discarded users will not be uploaded.`,
        route: null,
        widgetName: 'import-users',
      },
      uploadUsersInfo: {
        widgetTitle: 'Upload New Users',
        linkTitle: null,
        widgetDescription: `Select the agency and new user file (.csv only) to add multiple users
        at one time. Successfully added users can be accessed from the user management screen.`,
        widgetDescriptionFooter: `Existing user details will not be added/upldated. Existing user
        details can be edited from the user management screen.`,
        route: null,
        widgetName: 'upload-users',
      },
      downloadTemplateInfo: {
        widgetTitle: 'Download Template File',
        linkTitle: null,
        widgetDescription: `Download this template file (.csv) to ensure a successful import. The
        following information is required to create a new user profile.`,
        route: null,
        widgetName: 'download-file',
      },
    };
  },
  components: {
    DashboardWidget,
  },
  methods: {
    hasUserList() {
      const importUsers = this.$store.state.importUsers;

      return (importUsers && importUsers.userList && importUsers.userList.dataRows && importUsers.userList.dataRows.length);
    },
    widgetClasses(widgetInfo) { // TODO: Abstract to helper class
      return `${widgetInfo.widgetName} no-padding`;
    },
    reportTitle() { // TODO: Abstract to helper class
      return this.$router.currentRoute.meta.title;
    },
  },
};
</script>
<style scoped>
.card {
  border: none !important;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/user/ImportUsers.vue?16747d22